import { createApi } from '@reduxjs/toolkit/query/react'

import {
  infinitePaginationQueryOptions,
  InfinitePaginationRequest,
  InfinitePaginationResponse,
} from '@/model/pagination'
import { RelatedSimpleUser } from '@/redux/user'
import { baseQuery } from '@/redux/utils'

export interface ActivityLog {
  content: string
  createdAt: number
  id: number
  user: RelatedSimpleUser
}

export interface ReadMineActivityLogRequest {
  competitionId: number
  limit: number
}

export const activityLogSlice = createApi({
  reducerPath: 'activityLog',
  baseQuery,
  endpoints: builder => ({
    readMineActivityLog: builder.infiniteQuery<InfinitePaginationResponse<ActivityLog>, number, InfinitePaginationRequest>({
      infiniteQueryOptions: infinitePaginationQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/activity-log/mine',
        params: {
          competitionId: queryArg,
          ...pageParam,
        },
      }),
    }),
  }),
})

export const {
  useReadMineActivityLogInfiniteQuery,
} = activityLogSlice
